import React, { Fragment } from 'react';
import PropTypes from 'prop-types';
import { useForm } from 'react-hook-form';
import { yupResolver } from '@hookform/resolvers/yup';
import * as yup from 'yup';
import Input from '../input/Input';
import Button from '../button/Button';
import * as classes from './SmeLendingForm.module.scss';

const createValidator = (isAccountHolder) => {
  return yup.object().shape({
    firstName: yup.string().required('Please enter your first name').max(256, 'Please enter fewer than 256 characters'),
    lastName: yup.string().required('Please enter your last name').max(256, 'Please enter fewer than 256 characters'),
    ...(isAccountHolder
      ? {
          accountNumber: yup
            .string()
            .required('Please enter your account number')
            .matches(/^\d{8}$/, 'Your account number should be 8 digits long')
        }
      : {
          applicantDateOfBirth: yup
            .date()
            .max(new Date(), 'This cannot be a date in the future')
            .typeError('Please enter a valid date'),
          natureOfBusiness: yup.string().required('Please tell us what your business does')
        }),
    emailAddress: yup.string().email('Please enter a valid email address').required('Please enter your email address'),
    mobilePhoneNumber: yup
      .string()
      .required('Please enter your mobile phone number')
      .max(20, 'Your mobile number must be less than 20 digits')
  });
};

function Step4({ isAccountHolder, onSubmit }) {
  const {
    register,
    handleSubmit,
    formState: { errors }
  } = useForm({
    mode: 'onTouched',
    resolver: yupResolver(createValidator(isAccountHolder)),
    shouldUnregister: true
  });

  return (
    <form
      onSubmit={handleSubmit((data) => {
        if (data.applicantDateOfBirth) {
          const year = data.applicantDateOfBirth.getFullYear();
          const month = (data.applicantDateOfBirth.getMonth() + 1).toString().padStart(2, '0');
          const day = data.applicantDateOfBirth.getDate().toString().padStart(2, '0');
          data.applicantDateOfBirth = `${year}-${month}-${day}`;
        }

        onSubmit(data, 5);
      })}
      className={classes.step}
    >
      <Input id="firstName" label="What is your first name?" error={errors.firstName} {...register('firstName')} />

      <Input id="lastName" label="What is your last name?" error={errors.lastName} {...register('lastName')} />

      {isAccountHolder ? (
        <Input
          id="accountNumber"
          label="What is your Starling account number?"
          error={errors.accountNumber}
          {...register('accountNumber')}
        />
      ) : (
        <Fragment>
          <Input
            id="applicantDateOfBirth"
            type="date"
            label="What is your date of birth?"
            error={errors.applicantDateOfBirth}
            {...register('applicantDateOfBirth')}
          />

          <Input
            id="natureOfBusiness"
            label="What does your business do (i.e. what is the nature of your business activity)?"
            error={errors.natureOfBusiness}
            {...register('natureOfBusiness')}
          />
        </Fragment>
      )}

      <Input
        id="emailAddress"
        label="What is your email address?"
        error={errors.emailAddress}
        {...register('emailAddress')}
      />

      <Input
        id="mobilePhoneNumber"
        type="tel"
        label="What is your mobile number?"
        error={errors.mobilePhoneNumber}
        {...register('mobilePhoneNumber')}
      />

      <Button variant="secondary">Next</Button>
    </form>
  );
}
Step4.propTypes = {
  isAccountHolder: PropTypes.bool,
  onSubmit: PropTypes.func
};

export default Step4;
